module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_camera-82db10ad5156724f488e609ce9d5e1b7.svg";